import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/footer";
import Contactus from "../components/Contactus";

const ContactUs = () => {
  return (
    <>
      {/* Helmet SEO tags */}
      <Helmet>
        <title>Contact Us | Iklim Digitals</title>
        <meta
          name="description"
          content="Get in touch with Iklim Digitals, your Ethiopian digital marketing partner. Contact us for branding, advertising, content production, and web development inquiries."
        />
        <meta
          name="keywords"
          content="Iklim Digitals contact, Ethiopian digital marketing, branding, advertising, content production, web development"
        />
      </Helmet>

      
      <Header />
      <Contactus />
      <Footer />
    </>
  );
};

export default ContactUs;
